import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/document-templates/$templateId')({
  staticData: { breadcrumb: 'Template Detail', breadcrumbKey: 'K_BREADCRUMB_TEMPLATE_DETAIL' },
  validateSearch: (search: Record<string, unknown>) => ({
    edit: search.edit === 'true' || search.edit === true,
  }),
});
